import React from 'react';
import { Button, Card, Image } from 'react-bootstrap';
import styles from './SSOProviderCard.module.css';
import classNames from 'classnames';

export const SSOProviderCard = ({ ssoSettings, provider, handleActivate, handleDeactivate, handleEdit, isDirty }) => {
  const isEnabled = () => {
    if (!ssoSettings) {
      return false;
    }

    if (ssoSettings.identityProviders) {
      return ssoSettings.identityProviders.some(p => p.provider === provider.default.provider);
    }

    return ssoSettings.provider === provider.default.provider;
  };

  const selectedProvider = (() => {
    if (!ssoSettings) {
      return null;
    }

    if (ssoSettings.identityProviders) {
      return ssoSettings.identityProviders.find(p => p.provider === provider.default.provider);
    }

    return ssoSettings.provider === provider.default.provider ? ssoSettings : null;
  })();

  return (
    <Card className={classNames(styles.root, {[styles.dirty]: isDirty})}>
      <Card.Body className={styles.container}>
        <div className={styles.header}>
          <Image src={provider.icon} alt="Entra" />
          <span className={styles.label}>{provider.label}</span>
        </div>
        <div className={styles.body}>{provider.description}</div>
        <div className={styles.buttons}>
          {isEnabled() ? (
            <>
              <Button onClick={() => handleEdit(selectedProvider)} variant='secondary'>Edit</Button>
              <Button onClick={() => handleDeactivate(provider)}>Deactivate</Button>              
            </>
          ) : (
            <Button onClick={() => handleActivate(provider)}>Activate</Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
